/**
 * 用戶相關業務邏輯服務
 * 封裝所有用戶相關的 API 調用
 */

import { buildApiUrl, apiCall } from './apiService';

/**
 * 獲取當前登入用戶資訊
 * @param {Function} getAccessToken - 獲取 token 的函數
 * @param {Object} tokenRef - token 的 ref 對象
 * @returns {Promise<Object|null>} - 用戶資訊或 null
 */
export const fetchCurrentUser = async (getAccessToken, tokenRef) => {
  const url = buildApiUrl('api/get_current_user');
  const response = await apiCall(url, { method: 'GET' }, getAccessToken, tokenRef);
  
  if (response.ok) {
    return await response.json();
  } else {
    console.error("Failed to fetch current user:", response.statusText);
    return null;
  }
};

/**
 * 組織代碼映射表
 */
export const ORG_LIST = {
  康軒: "KS",
  青山: "KCQS",
  秀岡: "KCXG",
  新竹: "KCHC",
  南京: "NJ",
  常熟: "KCCS",
  昆山: "KCEC",
  合肥: "KCHF",
  台州: "KCTZ",
  西安: "KCXA"
};

/**
 * 根據用戶資訊判斷預設組織
 * @param {Object} userData - 用戶資料對象
 * @returns {string|null} - 組織代碼或 null
 */
export const getDefaultOrg = (userData) => {
  if (!userData || !userData.onPremisesDistinguishedName) {
    return null;
  }
  
  const userInfo = userData.onPremisesDistinguishedName.toString();
  if (!userInfo) {
    return null;
  }

  // 檢查用戶資訊中是否包含組織名稱
  for (const [orgName, orgCode] of Object.entries(ORG_LIST)) {
    if (userInfo.includes(orgName)) {
      return orgCode;
    }
  }
  
  // 如果都沒有，返回預設值
  return "KS";
};

